import EventTileDetails from './event-tile-details'
export default EventTileDetails
